import "babel-polyfill";
import Vue from "vue";
import Vuex from "vuex";
import VuexORM from "@vuex-orm/core";
// import VuexORMAxios from "@vuex-orm/plugin-axios";
import database from "./database";
// import { API_BASE_URL } from "./../globalVars";

Vue.use(Vuex);

// VuexORM.use(VuexORMAxios, {
//   database,
//   http: {
//     baseURL: API_BASE_URL,
//     url: "/",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json"
//     },
//     access_token: getAccessToken()
//   }
// });

const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  plugins: [VuexORM.install(database)]
});

export default store;

// function getAccessToken() {
//   return localStorage.getItem("access_token");
// }
